import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { AppConfig } from './app-config';

@Injectable()
export class AppConfigService {
  static appConfig : AppConfig;
  private dataLoc: string;
  constructor(private handler: HttpBackend) { }

  loadAppConfig() {
     this.dataLoc='./assets/environments/environment.json'; 
    // this.dataLoc='./assets/environments/environment-dev.json'; 
    return new Promise<void>((resolve, reject) =>  {
      new HttpClient(this.handler).get(this.dataLoc).toPromise().then((response: AppConfig) => {
        AppConfigService.appConfig = <AppConfig>response;
        resolve();
      }).catch((response: any) => {
        reject(`Could not load file '${this.dataLoc}': ${JSON.stringify(response)}`);
     });
    });
  }
  getConfig() {
    return AppConfigService.appConfig;
  }
}
